// extracted by mini-css-extract-plugin
export var editButton = "_oi-0";